//Redux action types

//Statistics (Holdings)
export const FETCH_ALL_HOLDINGS = "FETCH_ALL_HOLDINGS";
export const ADD_HOLDING = "ADD_HOLDING";
export const UPDATE_HOLDING = "UPDATE_HOLDING";
export const DELETE_HOLDING = "DELETE_HOLDING"

//Transactions
export const FETCH_ALL_TRANSACTIONS = "FETCH_ALL_TRANSACTIONS";
export const ADD_TRANSACTION = "ADD_TRANSACTION";

//Auth
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const AUTH_ERROR = "AUTH_ERROR"
export const CLEAR_AUTH_ERROR = "CLEAR_AUTH_ERROR"

//Error and loading handling
export const SET_ERROR = "SET_ERROR"
export const CLEAR_ERROR = "CLEAR_ERROR"
export const START_LOADING = "START_LOADING"
export const STOP_LOADING = "STOP_LOADING"

